import React from 'react';
import { useDispatch } from 'react-redux';
import { useFlightProvider } from '@src/features/order/provider';
import { ArcDroneMarker, setMapCenter } from '@src/core/controllers';
import { useDroneRotations } from '@src/features/drone/hooks/useDroneRotations';
import { FlightDroneProps } from './types';

const FlightDrone: React.FC<FlightDroneProps> = (props) => {
  const { drone, isOnMission = false } = props;
  const dispatch = useDispatch();
  const { flightData } = useFlightProvider();
  const { rotations } = useDroneRotations(flightData);

  const droneLat = Number(drone?.latitude);
  const droneLng = Number(drone?.longitude);

  const flightLat = Number(flightData?.latitude);
  const flightLng = Number(flightData?.longitude);

  const position = {
    lat: isNaN(flightLat) ? droneLat : flightLat,
    lng: isNaN(flightLng) ? droneLng : flightLng,
  };

  const rotation =
    drone?.serialNumber && typeof rotations[drone.serialNumber] === 'number'
      ? rotations[drone.serialNumber]
      : undefined;

  React.useEffect(() => {
    if (isNaN(droneLat) || isNaN(droneLng)) return;
    dispatch(setMapCenter({ lat: droneLat, lng: droneLng }));
  }, [droneLat, droneLng, dispatch]);

  if (isOnMission) {
    return (
      <ArcDroneMarker.missionArrow
        position={position}
        rotation={rotation}
      />
    );
  }

  return <ArcDroneMarker.idleArrow position={position} />;
};

export default FlightDrone;